var React = require('react');

function Dropdownlight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_71","data-name":"Path 71","d":"M-20147.078-15088.511l4,4,4-4","transform":"translate(20147.432 15088.864)","fill":"none","stroke":"white","strokeWidth":"1"}));
}

Dropdownlight.defaultProps = {"width":"8.707","height":"5.061","viewBox":"0 0 8.707 5.061"};

module.exports = Dropdownlight;

Dropdownlight.default = Dropdownlight;
